import type { LiabilityFormLayout } from "../types";

export const liabilityNameLayout = (): LiabilityFormLayout => {
  return {
    render: 'name'
  }
}
